import * as React from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Panel, ListGroup, Button, FormControl } from 'react-bootstrap';
import { bind, inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { IOrt, IOrtsListeResponse } from '../../models/ApiTypes';
import { ArbeitsmittelItem } from './ArbeitsmittelListe';
import Callout from '../site/Callout';
import FilterBox from '../site/FilterBox';

type ArbeitsmittelListItemAuswahlCallback = (ort: IOrt) => void;

interface IArbeitsmittelSetProps {
  arbeitsmittelSet: IOrt;
  uebersicht?: boolean;
  onArbeitsmittelSetAuswahl?: ArbeitsmittelListItemAuswahlCallback;
}

/** Zeigt ein einzelnes Arbeitsmittelset mit einen Arbeitsmitel und optionaler Statusinformationen an */
class ArbeitsmittelSet extends React.Component<IArbeitsmittelSetProps, {}> {
  render() {
    const { arbeitsmittelSet, onArbeitsmittelSetAuswahl } = this.props;
    const inaktiv = arbeitsmittelSet.status.toLowerCase() === 'inaktiv';
    const amAbgelaufen = arbeitsmittelSet.arbeitsmittel.some((element) => element.gueltigtage !== undefined && element.gueltigtage < 0);
    const amAktiv = arbeitsmittelSet.arbeitsmittel.every((element) => (element.amstatus.toLowerCase() === 'aktiv' || element.amstatus.toLowerCase() === 'qualifi'));
    const selectable = amAktiv && !amAbgelaufen;
    const anzahlInQuali = arbeitsmittelSet.arbeitsmittel.filter(e => e.amstatus.toLowerCase() === 'qualifi').length;
    return (
      <div>
        <Panel
          collapsible={true}
          defaultExpanded={true}
          bsStyle={selectable ? 'success' : 'danger'}
          header= {`${arbeitsmittelSet.name} (${arbeitsmittelSet.lizenznehmer})`}
          footer={
            onArbeitsmittelSetAuswahl ? (
              <div className="text-right">
                {selectable && !inaktiv && <Button bsStyle="default" onClick={() => onArbeitsmittelSetAuswahl(arbeitsmittelSet)}>Auswählen</Button>}
              </div>
            ) : null
          }
          >
          <ListGroup fill={true}>
            {arbeitsmittelSet.arbeitsmittel.map((arbeitsmittel, index) => (
              <ArbeitsmittelItem key={index} arbeitsmittel={arbeitsmittel} detailansicht={this.props.uebersicht ? this.props.uebersicht : false}/>
            ))}
          </ListGroup>
          {inaktiv && <Callout bsStyle="danger">Dieses Set wurde nicht freigegeben.</Callout>}
          {!inaktiv && !selectable &&
            <Callout bsStyle="danger">Set kann nicht verwendet werden, nicht alle Arbeitsmittel sind freigegeben oder gültig.</Callout>
          }
          {onArbeitsmittelSetAuswahl && !inaktiv && (anzahlInQuali > 0 ) &&
            <Callout bsStyle="default">In Qualifizierung befindliche Messmittel werden nicht in den Vorgang übernommen.</Callout>
          }
        </Panel>
      </div>
    );
  }
}

/** Kapselt das Filtern der Arbeitsmittelliste  */
class ListFilter {
  @observable filter: string;
  @observable sets: IOrt[];

  @action set(sets: IOrtsListeResponse) {
    this.sets = sets;
  }

  @computed get filtered() {
    if (this.filter) {
      return this.sets ? this.sets.filter(el => el.name.toLocaleLowerCase().includes(this.filter)) : [];
    } else {
      return this.sets;
    }
  }

  @action setFilter(filter: string) {
    this.filter = filter.toLocaleLowerCase();
  }
}

interface IArbeitsmittelAuswahlProps {
  title?: string;
  kategorie?: string;
  uebersicht?: boolean;
  onArbeitsmittelSetAuswahl?: ArbeitsmittelListItemAuswahlCallback;
}

/** Zeigt die Liste der dem angemeldeten Nutzer freigeschalteten Arbeitsmittelsets an */
@observer
export default class ArbeitsmittelAuswahl extends React.Component<IArbeitsmittelAuswahlProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  arbeitsmittelSets: ListFilter = new ListFilter();

  async componentDidMount() {
    const sets = await this.apiStore.orte(this.props.kategorie ? this.props.kategorie : '');
    if (sets.ok) {
      this.arbeitsmittelSets.set(sets.json);
    }
  }

  @bind @action handleFilterList(event: React.FormEvent<FormControl>) {
    let filterText = (event.target as HTMLInputElement).value;
    this.arbeitsmittelSets.setFilter(filterText);
  }

  render() {
    return (
      <div className="maxwidth">
        <h2>{this.props.title ? this.props.title : 'Arbeitsmittel-Sets'}</h2>
        <FilterBox onChange={this.handleFilterList}/>
        {!this.arbeitsmittelSets.filtered ? (
          <div>lade Arbeitsmittelsets...</div>
        ) : (this.arbeitsmittelSets.filtered.length === 0) ? (
          <div>Keine Arbeitsmittelsets für dieses Verfahren vorhanden</div>
        ) : this.arbeitsmittelSets.filtered.map((arbeitsmittelSet, index) => (
          <ArbeitsmittelSet
            key={index}
            arbeitsmittelSet={arbeitsmittelSet}
            uebersicht={this.props.uebersicht}
            onArbeitsmittelSetAuswahl={this.props.onArbeitsmittelSetAuswahl}
          />
        ))}
        <div className="text-right">
          <Button onClick={() => this.uiStore.navigateBack()}>Abbrechen</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/arbeitsmittel/ArbeitsmittelAuswahl.tsx